//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LoginForm from "../components/LoginForm.vue";
import { Toast } from "./../utils/helpers";
import authorizationAPI from "./../apis/authorization.js";

export default {
  name: "adminSignIn",
  components: {
    LoginForm,
  },
  data() {
    return {};
  },
  methods: {
    async handleSubmit(formData) {
      try {
        const { account, password } = formData;

        const response = await authorizationAPI.adminSignIn({
          account: account,
          password: password,
        });

        const { data } = response;
        if (data.status !== "success") {
          throw new Error(data.message);
        }

        // 將 token 存入 localStorage
        localStorage.setItem("token", data.token);

        // 透過 setCurrentUser 把管理者資料存到 vuex 的 state 中
        await this.$store.commit("setCurrentUser", data.data);

        Toast.fire({
          icon: "success",
          title: data.message,
        });
        this.$router.push("/admin");
      } catch (error) {
        Toast.fire({
          icon: "warning",
          title: error.message,
        });
      }
    },
  },
};
